import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { key: 1 }

import { onMounted, reactive, ref } from "vue";
import { AdminService } from "@/api/services/AdminService";
import { ListRequest } from "@/api/models/ListRequest";
import { message } from "ant-design-vue";
import dayjs from "dayjs";
import { ColumnType } from "ant-design-vue/lib/table";
import { Admin } from "@/api/models/admin/Admin";
import { AdminAddRequest } from "@/api/models/admin/AdminAddRequest";
import { AdminUpdateRequest } from "@/api/models/admin/AdminUpdateRequest";


export default /*@__PURE__*/_defineComponent({
  __name: 'AdminView',
  setup(__props) {

const total = ref<number>(0);

const listRequest = reactive<ListRequest>({
  current: 1,
  size: 20,
  content: "",
});

const mailList = ref<Admin[]>([]);

const handleList = async () => {
  const res = await AdminService.ListAll(listRequest);
  if (res.code === 0) {
    mailList.value = res.data.records;
    total.value = res.data.total;
  } else {
    message.error(res.msg);
  }
};

onMounted(async () => {
  await handleList();
});

const handleChange = (page: number, pageSize: number) => {
  listRequest.current = page;
  listRequest.size = pageSize;
  handleList();
};

const openAdd = ref(false);

const addRequest = reactive<AdminAddRequest>({
  account: "",
  password: "",
  check_password: "",
});

const submitAdd = async () => {
  const res = await AdminService.Add(addRequest);
  if (res.code === 0) {
    message.success("添加成功");
    setTimeout(() => location.reload(), 1000);
  } else {
    message.error(res.msg);
  }
};

const openUpdate = ref(false);

const updateRequest = reactive<AdminUpdateRequest>({
  id: 0,
  is_delete: 1,
  account: "",
  password: "",
  check_password: "",
});

const handleUpdate = (record: Admin) => {
  openUpdate.value = true;
  updateRequest.account = record.account;
  updateRequest.id = record.id;
  updateRequest.is_delete = record.is_delete;
};

const submitUpdate = async () => {
  const res = await AdminService.Update(updateRequest);
  if (res.code === 0) {
    message.success("修改成功");
    setTimeout(() => location.reload(), 1000);
  } else {
    message.error(res.msg);
  }
};

const submitDelete = async (record: Admin) => {
  const res = await AdminService.Delete(record.id);
  if (res.code === 0) {
    message.success("删除成功");
    setTimeout(() => location.reload(), 1000);
  } else {
    message.error(res.msg);
  }
};

const submitDrop = async (record: Admin) => {
  const res = await AdminService.Drop(record.id);
  if (res.code === 0) {
    message.success("删除成功");
    setTimeout(() => location.reload(), 1000);
  } else {
    message.error(res.msg);
  }
};

const columns: ColumnType[] = [
  {
    title: "Id",
    dataIndex: "id",
    align: "center",
  },
  {
    title: "账号",
    dataIndex: "account",
    align: "center",
  },
  {
    title: "状态",
    dataIndex: "is_delete",
    align: "center",
  },
  {
    title: "创建时间",
    dataIndex: "create_at",
    align: "center",
  },
  {
    title: "操作",
    dataIndex: "operator",
    align: "center",
  },
];

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input_password = _resolveComponent("a-input-password")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_button, {
      type: "primary",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (openAdd.value = true)),
      style: {"margin-bottom":"16px"}
    }, {
      default: _withCtx(() => _cache[10] || (_cache[10] = [
        _createTextVNode(" 添加管理员 ")
      ])),
      _: 1
    }),
    _createVNode(_component_a_table, {
      columns: columns,
      "data-source": mailList.value,
      pagination: {
        current: listRequest.current,
        pageSize: listRequest.size,
        total: total.value,
        onChange: handleChange,
      },
      bordered: ""
    }, {
      bodyCell: _withCtx(({ column, record }) => [
        (column.dataIndex === 'is_delete')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (record.is_delete === 1)
                ? (_openBlock(), _createBlock(_component_a_tag, {
                    key: 0,
                    color: "green"
                  }, {
                    default: _withCtx(() => _cache[11] || (_cache[11] = [
                      _createTextVNode("正常")
                    ])),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (record.is_delete === 2)
                ? (_openBlock(), _createBlock(_component_a_tag, {
                    key: 1,
                    color: "red"
                  }, {
                    default: _withCtx(() => _cache[12] || (_cache[12] = [
                      _createTextVNode("回收站")
                    ])),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ], 64))
          : (column.dataIndex === 'create_at')
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_unref(dayjs)(record.create_at).format("YYYY-MM-DD HH:mm:ss")), 1))
            : (column.dataIndex === 'operator')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _createVNode(_component_a_button, {
                    onClick: ($event: any) => (handleUpdate(record)),
                    type: "primary",
                    style: { marginRight: '8px' }
                  }, {
                    default: _withCtx(() => _cache[13] || (_cache[13] = [
                      _createTextVNode("编辑 ")
                    ])),
                    _: 2
                  }, 1032, ["onClick"]),
                  _createVNode(_component_a_button, {
                    onClick: ($event: any) => (submitDelete(record)),
                    type: "primary",
                    style: {
              backgroundColor: '#ff7a45',
              color: 'white',
              marginRight: '8px',
            }
                  }, {
                    default: _withCtx(() => _cache[14] || (_cache[14] = [
                      _createTextVNode("删除 ")
                    ])),
                    _: 2
                  }, 1032, ["onClick"]),
                  _createVNode(_component_a_button, {
                    onClick: ($event: any) => (submitDrop(record)),
                    type: "primary",
                    style: {
              backgroundColor: '#ff4d4f',
              color: 'white',
            }
                  }, {
                    default: _withCtx(() => _cache[15] || (_cache[15] = [
                      _createTextVNode("彻底删除 ")
                    ])),
                    _: 2
                  }, 1032, ["onClick"])
                ], 64))
              : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["data-source", "pagination"]),
    _createVNode(_component_a_modal, {
      open: openAdd.value,
      "onUpdate:open": _cache[4] || (_cache[4] = ($event: any) => ((openAdd).value = $event)),
      title: "添加管理员数据",
      onOk: submitAdd,
      cancelText: "取消"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, { model: addRequest }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, { label: "管理员名称" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: addRequest.account,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((addRequest.account) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "密码" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input_password, {
                  value: addRequest.password,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((addRequest.password) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "确认密码" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input_password, {
                  value: addRequest.check_password,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((addRequest.check_password) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["open"]),
    _createVNode(_component_a_modal, {
      open: openUpdate.value,
      "onUpdate:open": _cache[9] || (_cache[9] = ($event: any) => ((openUpdate).value = $event)),
      title: "修改快递数据",
      onOk: submitUpdate,
      cancelText: "取消"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          model: updateRequest,
          style: {"margin-top":"20px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, { label: "管理员名称" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: updateRequest.account,
                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((updateRequest.account) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "密码" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input_password, {
                  value: updateRequest.password,
                  "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((updateRequest.password) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "确认密码" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input_password, {
                  value: updateRequest.check_password,
                  "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((updateRequest.check_password) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "状态" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  value: updateRequest.is_delete,
                  "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((updateRequest.is_delete) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select_option, { value: 1 }, {
                      default: _withCtx(() => _cache[16] || (_cache[16] = [
                        _createTextVNode("正常")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_a_select_option, { value: 2 }, {
                      default: _withCtx(() => _cache[17] || (_cache[17] = [
                        _createTextVNode("回收站")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["open"])
  ]))
}
}

})